import gql from 'graphql-tag';

export const NAME = 'compositions_CaseCreator_createCaseRequestLineMutation';

const query = gql`
  mutation ${NAME} ($caseId: ID!) {
    createCaseRequestLine(input: { caseId: $caseId, requestLine: {} }) {
      requestLine { id }
    }
  }
`;

export default query;



// WEBPACK FOOTER //
// ./src/compositions/CaseCreator/createCaseRequestLineMutation.js